<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">

            <div class="d-flex flex-column flex-xl-row w-100 align-items-start justify-content-start mb-5">

                <div class="d-flex flex-grow-1 align-items-xl-center mb-4 mb-xl-0 flex-column flex-sm-row w-100">
                    <b-button
                            variant="link"
                            class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap p-0 mb-4"
                            @click="back()">
                        <b-icon icon="chevron-left" class="mr-2"/>
                        <span>Назад</span>
                    </b-button>

                    <div class="d-flex flex-grow-1 align-items-baseline justify-content-center flex-column flex-sm-row mb-4"
                         :key="objectKey + '-header'">
                        <span class="h3 mb-2 mb-lg-0" v-if="!object.id">Порода</span>
                        <span class="mb-2 mb-lg-0 mr-3 d-flex flex-column align-items-center justify-content-center" v-else>
                            <span class="h3">{{ header }}</span>
                            <small class="text-secondary">{{ object.speciesObject.name }}</small>
                        </span>
                        <sup><small v-if="!object.id" class="text-secondary ml-2">Новая</small></sup>
                    </div>
                </div>
            </div>

            <div id="form" class="d-flex flex-wrap">

                <form-field  class="col-xs-12 col-lg-8 required mb-2"
                             :label="getFieldLabel('name')"
                             :editable="getAbility('name')"
                             :value="object.shortName"
                             :feedback="liveFeedback('name')">
                    <template #field>
                        <b-form-input
                            id="name"
                            class="w-100"
                            type="text"
                            v-model="$v.form.name.$model"
                            :state="validateState('name')">
                        </b-form-input>
                    </template>
                </form-field>

                <form-field :label="getFieldLabel('species')"
                            class="col-xs-12 col-lg-8 required mb-2"
                            :editable="getAbility('species')"
                            :feedback="liveFeedback('species')"
                            :value="object.species"
                            :key="objectKey + 'species'">
                    <template #field>
                        <div class="d-flex">
                            <single-select name="species"
                                           class="flex-grow-1 mr-2"
                                   v-model="form['speciesObject']"
                                   :url="speciesUrl"
                                   :label="getFieldLabel('species')"
                                   :state="getValidationClass('species')"
                                   v-on:select-changed="onModelObjectSingleSelectChanged"
                                   v-on:select-cleared="onModelObjectSingleSelectCleared" />
                            <b-button class="flex-grow-0" @click="showAddSpeciesModal" v-if="canCreateSpecies">
                                <b-icon icon="plus" />
                                <span>Добавить вид</span>
                            </b-button>
                        </div>
                    </template>
                </form-field>

            </div>

            <object-form-buttons :has-changes="hasChanges"
                 :object-exists="Boolean(object.id)"
                 @object-create="onCreate"
                 @object-update="updateObject"
                 @object-cancel-changes="cancelChanges" class="mb-5"/>

        </b-card>

        <stub :failed-loading="failedLoading" v-else />

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>


        <b-modal id="add-species" hide-footer hide-header size="md">
            <template #default>
                <species-create-modal key="createdSpecies"
                                   @object-modal-closed="hideAddSpeciesModal"
                                   @object-modal-created="onSpeciesObjectCreated">
                </species-create-modal>
            </template>
        </b-modal>

    </div>
</template>

<script>
import {ObjectComponentMixin} from "@/components/Forms/ObjectComponentMixin";
import api from "@/api";
import {Breed} from "@/pages/AppPages/Catalogs/Animals/breed";
import ObjectFormButtons from "@/components/Forms/ObjectFormButtons";
import FormField from "@/components/Forms/FormField";
import SingleSelect from "@/components/Select/SingleSelect";
import ConfirmLeaveModal from "@/components/Forms/ConfirmLeaveModal";
import SpeciesCreateModal from "@/pages/AppPages/Catalogs/Animals/SpeciesCreateModal";
import Stub from "@/components/Stub.vue";
import {mapGetters} from "vuex";

export default {
    name: "BreedDetail",
    components: {Stub, SpeciesCreateModal, ConfirmLeaveModal, SingleSelect, FormField, ObjectFormButtons},
    mixins: [ ObjectComponentMixin ],
    props: {
        breedId: null,
    },
    data() {
        return {
            newSpecies: null
        }
    },
    computed: {
        ...mapGetters(['isInContractor', 'isMunicipalController', 'userOrganizationActivities', 'isSuperuser']),
        speciesUrl() {
            return api.species.default.list();
        },
        canCreateSpecies() {
            return this.isSuperuser || this.isMunicipalController
        }
    },
    methods: {
        showAddSpeciesModal() {
            this.$bvModal.show('add-species');
        },
        hideAddSpeciesModal() {
            this.$bvModal.hide('add-species');
        },
        onSpeciesObjectCreated(newSpecies) {
            this.form.species = newSpecies['id'];
            this.$v.form.species.$touch();
            this.form.speciesObject = newSpecies;
            this.hideAddSpeciesModal();
        }
    },
    beforeMount() {
        this.objectClass = Breed;
        this.objectId = this.breedId ? this.breedId : this.$route.params.id;
        this.apiEntryPoint = api.breeds;
        this.backRoute = 'breedList';
        this.nextRoute = 'breedDetail';
    },
    mounted() {
        this.onMount();
        this.resetForm();
    },
}
</script>

<style scoped>

</style>